import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  ViewNotificationDTO,
  NotificationListResponse,
  NotificationDetailResponse,
  UpdateNotificationRequest,
  NotificationQueryParams
} from '../models/notification.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private apiUrl = `${environment.apiUrl}/notifications`;

  constructor(private http: HttpClient) {}

  /**
   * Recupera la lista delle notifiche per l'utente corrente
   * @param params Query parameters per filtrare le notifiche
   * @returns Observable con la lista delle notifiche
   */
  getNotifications(params?: NotificationQueryParams): Observable<NotificationListResponse> {
    let httpParams = new HttpParams();

    if (params) {
      if (params.AccountId !== undefined) {
        httpParams = httpParams.set('AccountId', params.AccountId.toString());
      }
      if (params.Page !== undefined) {
        httpParams = httpParams.set('Page', params.Page.toString());
      }
      if (params.PageSize !== undefined) {
        httpParams = httpParams.set('PageSize', params.PageSize.toString());
      }
      if (params.CreatedFrom) {
        httpParams = httpParams.set('CreatedFrom', params.CreatedFrom);
      }
      if (params.CreatedTo) {
        httpParams = httpParams.set('CreatedTo', params.CreatedTo);
      }
      if (params.SortBy) {
        httpParams = httpParams.set('SortBy', params.SortBy);
      }
      if (params.Type) {
        httpParams = httpParams.set('Type', params.Type);
      }
    }

    return this.http.get<NotificationListResponse>(this.apiUrl, { params: httpParams });
  }

  /**
   * Recupera i dettagli di una singola notifica
   * @param id ID della notifica
   * @returns Observable con i dettagli della notifica
   */
  getNotification(id: number): Observable<NotificationDetailResponse> {
    return this.http.get<NotificationDetailResponse>(`${this.apiUrl}/${id}`);
  }

  /**
   * Segna una notifica come letta o non letta
   * @param id ID della notifica
   * @param isChecked true per segnare come letta, false per non letta
   * @returns Observable con la notifica aggiornata
   */
  updateNotificationStatus(id: number, isChecked: boolean): Observable<NotificationDetailResponse> {
    const request: UpdateNotificationRequest = {
      notification_is_checked: isChecked
    };
    return this.http.put<NotificationDetailResponse>(`${this.apiUrl}/${id}`, request);
  }

  /**
   * Segna una notifica come letta
   * @param id ID della notifica
   * @returns Observable con la notifica aggiornata
   */
  markAsRead(id: number): Observable<NotificationDetailResponse> {
    return this.updateNotificationStatus(id, true);
  }

  /**
   * Segna una notifica come non letta
   * @param id ID della notifica
   * @returns Observable con la notifica aggiornata
   */
  markAsUnread(id: number): Observable<NotificationDetailResponse> {
    return this.updateNotificationStatus(id, false);
  }

  /**
   * Conta le notifiche non lette
   * @param notifications Lista di notifiche
   * @returns Numero di notifiche non lette
   */
  countUnread(notifications: ViewNotificationDTO[]): number {
    return notifications.filter(n => !n.notification_is_checked).length;
  }
}

